/* websocket.js */

import { states } from '@/stores';
import { push as notificationPush } from '@/helpers/notifications';


const CFG = {
	serviceInterval: 5000,
};


export const websocket = {
	lock: false,
	handler: null,
	reconnectState: false,
	reconnectTimer: null,
	inspectorState: true,
	inspectorTimer: null,
	subscriptions: {
		connect: [],
		disconnect: [],
		message: [],
	},

	/* establish */
	establish: function() {
		return new Promise(
			(resolve, reject) => {
				if (this.handler || this.lock) {
					resolve();
					return;
				}
				const wso = states.pull('wso');
				if (!wso) {
					notificationPush('system', 'Websocket соединения не может быть открыто');
					resolve();
					return;
				}
				this.lock = true;
				const socket = new WebSocket(wso + '/ws');
				// onopen
				socket.onopen = () => {
					notificationPush('system', 'Открыто websocket соединение');
					this.handler = socket;
					if (this.reconnectTimer) {
						clearInterval(this.reconnectTimer);
						this.reconnectTimer = null;
					}
					this.reconnectState = true;
					this.inspectorState = true;
					this.inspectorTimer = setInterval(() => this.ping(), CFG.serviceInterval);
					this.lock = false;
					this.dispatch('connect', null);
					resolve();
				};
				// onclose
				socket.onclose = () => {
					if (this.handler)
						notificationPush('system', 'Закрыто websocket соединение');
					this.handler = null;
					if (this.inspectorTimer) {
						clearInterval(this.inspectorTimer);
						this.inspectorTimer = null;
					}
					if (this.reconnectState)
						this.reconnectTimer = setInterval(() => this.establish(), CFG.serviceInterval);
					this.lock = false;
					this.dispatch('disconnect', null);
					reject();
				};
				// onmessage
				socket.onmessage = (event) => {
					if (event.data === 'pong') {
						this.inspectorState = true;
						return;
					}
					this.dispatch('message', event.data);
				};
			}
		)
		.then(() => null)
		.catch(() => null);
	},
	
	/* disband */
	disband: function() {
		if (this.reconnectTimer) {
			clearInterval(this.reconnectTimer);
			this.reconnectTimer = null;
		}
		this.reconnectState = false;
		if (this.handler)
			this.handler.close();
	},

	/* dispatch */
	dispatch: function(event, data) {
		this.subscriptions[event].forEach(
			call => {
				call[0](data);
				if (call[1])
					this.off(event, call[0], call[1])
			}
		);
	},

	/* on */
	on: function(event, callback, once) {
		once = once ? true : false;
		this.subscriptions[event].push([ callback, once ]);
	},

	/* off */
	off: function(event, callback, once) {
		once = once ? true : false;
		const len = this.subscriptions[event].length;
        const temp = [];
        for (let i = len - 1; i >= 0; i--)
            if (this.subscriptions[event][i][0] === callback &&
					this.subscriptions[event][i][1] === once)
                temp.push(i);
        temp.forEach(
            i => this.subscriptions[event].splice(i, 1)
        );
	},
	
	/* send */
	send: function(message) {
		this.handler.send(message);
	},

	/* ping */
	ping: function() {
		if (this.inspectorState) {
			this.inspectorState = false;
			this.handler.send('ping');
		}
		else {
			this.handler.close();
		}
	},
	
	/* isEstablished */
	isEstablished() {
		return this.handler ? true : false;
	},

};
